import { format } from "date-fns";
import { sv } from "date-fns/locale";
import { Badge } from "@/components/ui/badge";
import {
  ArrowRightLeft, Plus, XCircle, CreditCard, CheckCircle2, RotateCcw, User, Settings,
} from "lucide-react";
import type { ActivityLogEntry } from "./types";

const ACTION_ICONS: Record<string, React.ReactNode> = {
  booking_created: <Plus className="h-3.5 w-3.5 text-green-600" />,
  booking_cancelled: <XCircle className="h-3.5 w-3.5 text-destructive" />,
  admin_cancelled: <XCircle className="h-3.5 w-3.5 text-destructive" />,
  player_added: <User className="h-3.5 w-3.5 text-blue-600" />,
  payment_received: <CreditCard className="h-3.5 w-3.5 text-green-600" />,
  payment_refunded: <RotateCcw className="h-3.5 w-3.5 text-amber-600" />,
  checked_in: <CheckCircle2 className="h-3.5 w-3.5 text-green-600" />,
  booking_moved: <ArrowRightLeft className="h-3.5 w-3.5 text-blue-600" />,
};

const ACTOR_LABELS: Record<string, string> = {
  player: "SPELARE",
  admin: "ADMIN",
  system: "SYSTEM",
};

interface BookingDetailLogProps {
  activityLog: ActivityLogEntry[];
}

export function BookingDetailLog({ activityLog }: BookingDetailLogProps) {
  if (activityLog.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-8">Ingen aktivitet loggad ännu</p>
    );
  }

  return (
    <div className="space-y-0 relative">
      <div className="absolute left-[11px] top-2 bottom-2 w-px bg-border" />
      {activityLog.map((entry) => (
        <div key={entry.id} className="flex items-start gap-3 py-2.5 relative">
          <div className="shrink-0 w-6 h-6 rounded-full bg-muted flex items-center justify-center z-10 border border-border">
            {ACTION_ICONS[entry.action] ?? <Settings className="h-3.5 w-3.5 text-muted-foreground" />}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm">{entry.description}</p>
            <div className="flex items-center gap-2 mt-0.5">
              <span className="text-xs text-muted-foreground">
                {format(new Date(entry.created_at), "d MMM HH:mm", { locale: sv })}
              </span>
              <Badge variant="outline" className="text-[10px] px-1.5 py-0 h-4">
                {ACTOR_LABELS[entry.actor_type ?? ""] ?? entry.actor_type}
              </Badge>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
